const CategoryList=[

    "clothing",
    "footware",
    "jwellery",
    "electronics"
    
    
    ];
    
    export default CategoryList;